import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FiUsers, FiCheck, FiShield } from "react-icons/fi";
import { AuthContext } from "../../context/AuthContext";
import { CommunityContext } from "../../context/CommunityContext";
import { Card, Badge, Button } from "../ui";
import uploadUrl from "../../utils/assetUrl";

export default function CommunityCard({ community }) {
  const { isAdmin } = useContext(AuthContext);
  const { joinedCommunities } = useContext(CommunityContext);
  const navigate = useNavigate();

  const isJoined = joinedCommunities.some((c) => c.id === community.id);
  const openCommunity = () => navigate(`/communities/${community.id}`);

  return (
    <Card className="group flex cursor-pointer flex-col overflow-hidden transition-shadow hover:shadow-soft" onClick={openCommunity}>
      <div className="relative h-32 w-full overflow-hidden bg-gradient-to-br from-primary-500 to-primary-700">
        {community.image && (
          <img
            src={uploadUrl(community.image)}
            alt=""
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        )}
        {isJoined && (
          <Badge variant="emerald" className="absolute right-3 top-3 bg-white/95">
            <FiCheck className="h-3 w-3" /> Member
          </Badge>
        )}
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-1 text-[15px] font-semibold text-slate-900">{community.name}</h3>
        <p className="mt-1 line-clamp-2 flex-1 text-sm text-slate-500">
          {community.description || "No description yet."}
        </p>
        <div className="mt-3 flex items-center gap-4 text-xs text-slate-400">
          <span className="flex items-center gap-1">
            <FiUsers className="h-3.5 w-3.5" /> {community.memberCount ?? community.members ?? 0} members
          </span>
        </div>
        <div className="mt-4">
          {isJoined ? (
            <Button variant="secondary" size="sm" className="w-full" onClick={openCommunity}>
              View community
            </Button>
          ) : isAdmin ? (
            <Button size="sm" className="w-full" onClick={openCommunity}>
              <FiShield className="h-3.5 w-3.5" /> Manage
            </Button>
          ) : (
            <Button size="sm" className="w-full" onClick={openCommunity}>
              View &amp; request to join
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
}
